import { Tile, isHonor, isSuited, tileNumber } from '../tiles';
import { GameState } from '../game/types';

/** 리치를 선언한 상대 자리들(자신 제외). */
export function riichiOpponents(state: GameState, seat: number): number[] {
  const out: number[] = [];
  for (let i = 0; i < state.players.length; i++) {
    if (i === seat) continue;
    if (state.players[i].riichi) out.push(i);
  }
  return out;
}

/** 어떤 자리의 버림패에 있으면 그 자리에 대해 '현물'(후리텐상 그 자리는 절대 론 불가 → 안전). */
function isGenbutsuAgainst(tile: Tile, state: GameState, seat: number): boolean {
  return state.players[seat].discards.includes(tile);
}

/** 리치 상대 '전원'에게 현물이면 절대 안전. */
export function isSafeAgainstAll(tile: Tile, state: GameState, riichiSeats: number[]): boolean {
  return riichiSeats.length > 0 && riichiSeats.every((s) => isGenbutsuAgainst(tile, state, s));
}

/** 방총 위험도(낮을수록 안전). 현물=0. 비현물은 패 종류·스지로 어림한 결정적 휴리스틱.
 *  - 중장패(3~7): 양면 대기에 가장 잘 걸려 가장 위험
 *  - 2/8 < 1/9 < 자패 순으로 안전
 *  - 스지(어떤 리치 상대가 n±3을 이미 버림): 양면 가능성↓ → 위험 완화
 *  리치 상대가 없으면 0(수비 무의미). */
export function tileDanger(tile: Tile, state: GameState, riichiSeats: number[]): number {
  if (riichiSeats.length === 0) return 0;
  if (isSafeAgainstAll(tile, state, riichiSeats)) return 0; // 현물

  let danger: number;
  if (isHonor(tile)) {
    danger = 2;
  } else {
    const n = tileNumber(tile); // 1..9
    if (n === 1 || n === 9) danger = 3;
    else if (n === 2 || n === 8) danger = 5;
    else danger = 8; // 3..7
  }

  // 스지 완화: 같은 수패에서 n-3 또는 n+3을 어떤 리치 상대가 버렸으면 양면 걸림이 줄어든다.
  if (isSuited(tile)) {
    const n = tileNumber(tile);
    const base = tile - (n - 1); // 같은 수패의 '1'
    const discarded = (num: number, s: number) =>
      num >= 1 && num <= 9 && state.players[s].discards.includes(base + (num - 1));
    const suji = riichiSeats.some((s) => discarded(n - 3, s) || discarded(n + 3, s));
    if (suji) danger = Math.max(1, danger - 3);
  }

  return danger;
}

/** 14장 중 가장 안전한(위험도 최소) 버림패. 동률이면 낮은 타일 번호(결정적). */
export function safestDiscard(hand14: readonly Tile[], state: GameState, riichiSeats: number[]): Tile {
  const distinct = Array.from(new Set(hand14)).sort((a, b) => a - b);
  let best = distinct[0];
  let bestDanger = Infinity;
  for (const t of distinct) {
    const d = tileDanger(t, state, riichiSeats);
    if (d < bestDanger) {
      bestDanger = d;
      best = t;
    }
  }
  return best;
}
